var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookingTvFrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15.22,
    viewBox: "0 0 18 15.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cooking_TV_French",
    "data-name": "Cooking TV French",
    transform: "translate(-0.212 -7.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1856",
    "data-name": "Group 1856",
    transform: "translate(0.212 7.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1855",
    "data-name": "Group 1855",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1854",
    "data-name": "Group 1854",
    transform: "translate(0 6.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8988",
    "data-name": "Path 8988",
    d: "M9.9,46.788H8.527a24.536,24.536,0,0,1-5.7-.4C1.068,45.922.212,44.955.212,43.428c0-3.228,4.038-5.854,9-5.854s9,2.626,9,5.854C18.212,46.788,14.173,46.788,9.9,46.788Zm-.686-.909H9.9c4.618,0,7.422-.165,7.422-2.452,0-2.727-3.637-4.946-8.108-4.946S1.1,40.7,1.1,43.428c0,1.1.583,1.718,1.949,2.077a24.025,24.025,0,0,0,5.475.375Z",
    transform: "translate(-0.212 -37.574)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8989",
    "data-name": "Path 8989",
    d: "M56.474,49.928a.454.454,0,0,1-.454-.454,4.118,4.118,0,0,1,4-4.22.454.454,0,0,1,0,.909,3.21,3.21,0,0,0-3.09,3.311A.454.454,0,0,1,56.474,49.928Z",
    transform: "translate(-45.07 -37.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8990",
    "data-name": "Path 8990",
    d: "M14.97,44.293a.454.454,0,0,1-.453-.436,4.647,4.647,0,0,1,3.4-4.895.454.454,0,0,1,.208.884,3.751,3.751,0,0,0-2.7,3.975.454.454,0,0,1-.436.472Z",
    transform: "translate(-11.687 -32.665)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8991",
    "data-name": "Path 8991",
    d: "M33.337,43.677a.454.454,0,0,1-.454-.454A4.714,4.714,0,0,1,37.472,38.3a.454.454,0,0,1,0,.909,3.817,3.817,0,0,0-3.681,4.013A.454.454,0,0,1,33.337,43.677Z",
    transform: "translate(-26.442 -32.148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8992",
    "data-name": "Path 8992",
    d: "M27.5,11.172a.452.452,0,0,1-.247-.074.489.489,0,0,1-.083-.068,2.133,2.133,0,0,1,.005-3.006.454.454,0,0,1,.643.642,1.223,1.223,0,0,0,0,1.727.454.454,0,0,1-.318.779Z",
    transform: "translate(-21.328 -7.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8993",
    "data-name": "Path 8993",
    d: "M29.441,22.9a.454.454,0,0,1-.321-.776,1.224,1.224,0,0,0,0-1.728.454.454,0,1,1,.643-.641,2.134,2.134,0,0,1,0,3.013A.455.455,0,0,1,29.441,22.9Z",
    transform: "translate(-23.281 -17.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8994",
    "data-name": "Path 8994",
    d: "M41.812,11.172a.453.453,0,0,1-.286-.1l-.03-.028-.008-.007a2.132,2.132,0,0,1,0-3.012.454.454,0,1,1,.643.642,1.222,1.222,0,0,0,0,1.723l.006.005a.454.454,0,0,1-.319.778Z",
    transform: "translate(-32.805 -7.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8995",
    "data-name": "Path 8995",
    d: "M43.756,22.9a.454.454,0,0,1-.321-.776,1.224,1.224,0,0,0,0-1.728.454.454,0,1,1,.643-.641,2.134,2.134,0,0,1,0,3.013A.454.454,0,0,1,43.756,22.9Z",
    transform: "translate(-34.758 -17.246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8996",
    "data-name": "Path 8996",
    d: "M56.123,11.173a.45.45,0,0,1-.216-.055.464.464,0,0,1-.118-.091,2.128,2.128,0,0,1,.009-3,.454.454,0,0,1,.643.642,1.219,1.219,0,0,0,0,1.727l.007.008a.454.454,0,0,1-.326.771Z",
    transform: "translate(-44.277 -7.892)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8997",
    "data-name": "Path 8997",
    d: "M58.074,22.9a.454.454,0,0,1-.321-.776,1.224,1.224,0,0,0,0-1.728.454.454,0,1,1,.643-.641,2.134,2.134,0,0,1,0,3.013A.455.455,0,0,1,58.074,22.9Z",
    transform: "translate(-46.237 -17.246)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookingTvFrench);
export default __webpack_public_path__ + "static/media/Cooking-TV-French.9faec91b33158eb1b41d17909f318c05.svg";
export { ForwardRef as ReactComponent };